<template>
  <form @submit.prevent="submit" class="form">
    <div class="form-wrap">
      <label for="name">{{ $t('costCenters.name') }}</label>
      <input v-model="costCenter.name" class="form-input" type="text" name="name" id="name" required />
    </div>

    <div class="form-wrap" v-if="zones.length > 0">
      <label>{{ $t('meta.zones') }}</label>

      <div v-for="group in zones" :key="group.area_uuid" style="margin-bottom: 1rem">
        <label class="checkbox-wrap">
          <input
            type="checkbox"
            :checked="allZonesOfGroupSelected(group)"
            @change="updateGroup(group, $event.target.checked)"
          />
          {{ group.area_name }}:
        </label>

        <label
          v-for="zone in group.zones"
          :key="zone.uuid"
          class="checkbox-wrap"
          style="margin-top: 0.5rem; margin-left: 2rem"
        >
          <input type="checkbox" :value="zone.uuid" v-model="zoneUuids" />
          {{ zone.name }}
        </label>
      </div>
    </div>

    <input type="submit" :value="$t('meta.save')" class="button button-green button-100 button-round" />
  </form>
</template>

<script>
import costCentersApi from '@/api/costCenters'

export default {
  inject: ['companyUser'],
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      costCenter: { ...this.value },
      zones: [],
      zoneUuids: [],
    }
  },
  watch: {
    value: {
      handler(costCenter) {
        this.costCenter = costCenter
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    updateGroup(group, checked) {
      const self = this

      if (checked) {
        // Select all items from the group
        group.zones.forEach(function (zone) {
          if (!self.zoneUuids.includes(zone.uuid)) {
            self.zoneUuids.push(zone.uuid)
          }
        })
      } else {
        // Unselect all items from the group
        group.zones.forEach(function (zone) {
          if (self.zoneUuids.includes(zone.uuid)) {
            self.zoneUuids = self.zoneUuids.filter(function (uuid) {
              return uuid !== zone.uuid
            })
          }
        })
      }
    },
    allZonesOfGroupSelected(group) {
      const self = this

      return group.zones.every(function (zone) {
        return self.zoneUuids.includes(zone.uuid)
      })
    },
    submit() {
      this.costCenter.zone_uuids = this.zoneUuids
      this.$emit('submit', this.costCenter)
    },
  },
  async mounted() {
    const self = this

    this.zones = await costCentersApi.getZones(this.companyUser.company_uuid, this.costCenter.uuid)

    this.zones.forEach(function (group) {
      group.zones.forEach(function (zone) {
        if (zone.selected) {
          self.zoneUuids.push(zone.uuid)
        }
      })
    })
  },
}
</script>
<style lang="scss">
@import '@/components/Form/Checkbox/Checkbox.scss';

input[type='checkbox'] {
  margin-left: !important 1rem;
}
</style>
